export const userRolValidation = (rolesHabilidatos, userData) => {
    const filteredArray = rolesHabilidatos.filter(value => userData.roles.includes(value))
    return filteredArray.length > 0
}
export const userRolValidationWithMail = (rolesHabilidatos, correosHabilitados, userData) => {
    let filteredMailArray, filteredArray
    try {
        if (correosHabilitados && correosHabilitados !== undefined) {
            filteredMailArray = correosHabilitados.includes(userData.email)
            return filteredMailArray
        }
        else {
            filteredArray = rolesHabilidatos.filter(value => userData.roles .includes(value))
            return filteredArray.length > 0
        }
    }
    catch (error) {
        return false
    }
}